import React from 'react'
import { Col, Card } from 'react-angle-dashboard-components'

export const ClaimDetail: React.FC<{
  title: string
  content: string | number
}> = ({ title, content }) => {
  return (
    <Col className="px-1">
      <Card className="p-3">
        <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
          {title}
        </small>
        <p>{content || ' - '}</p>
      </Card>
    </Col>
  )
}
